import { Component, OnInit, Injectable, ViewChild, ElementRef, Injector, EventEmitter } from '@angular/core';

import { LookupService } from 'src/service/lookup-filter-service';
import { KindBoard } from 'src/utils/enums';
import { PageBase } from 'src/app/shared/library/page.base';
import { InputBoardComponent } from 'src/app/Input/inputboard/inputboard.component';
import { TaskboardComponent } from 'src/app/Task/taskboard/taskboard.component';

@Component({
    selector: 'cp-mainpage',
    templateUrl: './mainpage.component.html',
    styleUrls: ['./mainpage.component.css'],
    standalone: false
})

@Injectable({ providedIn: 'root' })
export class MainPageComponent extends PageBase implements OnInit {

  @ViewChild('buttonTask') buttonTask: ElementRef<HTMLInputElement>;
  @ViewChild('buttonInput') buttonInput: ElementRef<HTMLInputElement>;
  @ViewChild('taskBoard', { static: true }) taskBoard: TaskboardComponent; // Acesso do lookup para outros componentes
  @ViewChild('inputBoard', { static: true }) inputBoard: InputBoardComponent; // Acesso do lookup para outros componentes


  IsTask = false;
  kind: KindBoard = KindBoard.Tarefa; // 0-tarefa 1-insumo

  constructor(public objInjector: Injector,
              public sampleFilterService: LookupService) {
    super(objInjector);
  }

  onReceiveLiterals(): void { }

  ngOnInit(): void {
    super.ngOnInit();
    if (!this.contextApplication.HasUserContext) {
      this.router.navigate(['']);
    }
    this.poNotification.setDefaultDuration(3000);
 
    if (sessionStorage.getItem('esconde-menu') !== null) {
      this.renderer2.addClass(document.body, 'esconde-menu');
    }
  }

  onClickBtnEvent(event: EventEmitter<any>) {
    if (event) {
      this.kind = Number(event['currentTarget']['value']);
      this.contextApplication.currentVision = Number(event['currentTarget']['value']);
      if (this.kind.valueOf() === KindBoard.Tarefa.valueOf()) {
        this.buttonTask.nativeElement.setAttribute('class', 'cp-button-selected');
        this.buttonInput.nativeElement.setAttribute('class', 'buttonUnSelected');
        this.IsTask = false;
      }
      else {
        this.buttonTask.nativeElement.setAttribute('class', 'buttonUnSelected');
        this.buttonInput.nativeElement.setAttribute('class', 'cp-button-selected');
        this.IsTask = true;
      }
    }
  }

  onClickRefresh(event: EventEmitter<string>): void {
    if (event) {
      if (this.IsTask){
        this.inputBoard.RefreshData();
      }
      else{
        this.taskBoard.RefreshData();
      }
    }
  }
}
